import { componentName, ButtonClass } from './ButtonClass';
import '@vaadin/button';

customElements.define(componentName, ButtonClass);

export { ButtonClass, componentName };
